import {SelectOption} from "./CommonUIElementTypes";

export let SelectUtility = {
    selectOptionForId: function (id: string, options?: SelectOption[]) {
        return (options || []).find((option) => '' + option.value === '' + id) || undefined
    },

    modelArrayToSelectOptions: function (
        modelArray: any[],
        valueProperty?: string,
        labelProperty?: string,
        labelFunction?: Function
    ) {
        return (modelArray || []).map(function (model) {
            let label
            if (labelFunction) {
                label = labelFunction(model)
            } else {
                label = model[labelProperty || 'name'];
            }
            return {
                value: model[valueProperty || 'id'],
                label: label
            }
        })
    }
}
